import { UserContext } from '~/app';
import { JobListingDetails } from '~/features/market/listings/job-listing/JobListingDetails';
import { ProviderJobListings } from '~/features/provider-hlx/job-listings/ProviderJobListings';

export const HlxListingsRoute = () => {
  const isProvider = UserContext.useSelector((state) =>
    state.matches({ $_AUTHENTICATED: '$_AUTHENTICATED_PROVIDER' })
  );

  if (isProvider) {
    return <ProviderJobListings />;
  }

  return <JobListingDetails />;
};
